import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75dc5672"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "test-mode"
}
const _hoisted_3 = {
  key: 1,
  class: "test-mode"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Hjem", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Kasse", -1))
const _hoisted_6 = {
  key: 0,
  class: "children"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/cash-till/#customers-new" }, "2 Ny kunde", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/cash-till/old-orders/" }, "5 Tidligere ordre", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/cash-till/invoices/" }, "6 Utestående fakturaer", -1))
const _hoisted_10 = {
  key: 0,
  href: "/cash-registers"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Kunder", -1))
const _hoisted_12 = {
  key: 0,
  class: "children"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/customers/list/" }, "1 Kunderegister", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/customers/discounts/" }, "2 Rabattgrupper", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/customers/provision/" }, "3 Provisjon", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/customers/newsletter/" }, "4 Ønsker nyhetsbrev", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Timeregistrering", -1))
const _hoisted_18 = {
  key: 0,
  class: "children"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/hours/register" }, "1 Registrere timer", -1))
const _hoisted_20 = {
  key: 0,
  href: "/hours/admin"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Produkter", -1))
const _hoisted_22 = {
  key: 0,
  class: "children"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/products/list-backorder/" }, "2 Bestillingsliste", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/products/list-category/" }, "3 Kategorier", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/products/count/" }, "6 Varetelling", -1))
const _hoisted_26 = {
  key: 0,
  href: "/products/list-supplier/"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "FAQer", -1))
const _hoisted_28 = {
  key: 0,
  class: "children"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "RUH", -1))
const _hoisted_30 = {
  key: 0,
  class: "children"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "line" }, null, -1))
const _hoisted_32 = { class: "unimportant" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Rapporter", -1))
const _hoisted_34 = {
  key: 0,
  class: "children"
}
const _hoisted_35 = {
  key: 0,
  href: "/reports/sales-statistics/"
}
const _hoisted_36 = {
  key: 2,
  href: "/reports/inventory/"
}
const _hoisted_37 = {
  key: 3,
  href: "/reports/registry-list/"
}
const _hoisted_38 = {
  key: 5,
  href: "/reports/lossy-orders"
}
const _hoisted_39 = {
  key: 6,
  href: "/reports/not-sold/"
}
const _hoisted_40 = {
  key: 7,
  href: "/reports/provision/"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/reports/must-backorder/" }, "10 Lav lagerverdi", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/reports/low-profit/" }, "11 Lav fortjeneste", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/reports/100-newest-products/" }, "12 Nye produkter", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/reports/100-changed-products" }, "13 Endrede produkter", -1))
const _hoisted_45 = { class: "unimportant" }
const _hoisted_46 = {
  class: "parent-link",
  href: "/reports/registry/"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Registrer oppgjør", -1))
const _hoisted_48 = {
  key: 1,
  class: "unimportant"
}
const _hoisted_49 = {
  class: "parent-link",
  href: "/user-management/"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Brukere", -1))
const _hoisted_51 = { class: "unimportant" }
const _hoisted_52 = {
  href: "/logout",
  class: "parent-link"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Logg ut", -1))
const _hoisted_54 = { class: "expand-toggle unimportant" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Link = _resolveComponent("Link")!
  const _component_CollapseTransition = _resolveComponent("CollapseTransition")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["nav", _ctx.classes])
  }, [
    (_ctx.store.env === 'staging' || _ctx.store.env === 'local')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.isSmall)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, "TEST"))
            : (_openBlock(), _createElementBlock("p", _hoisted_3, "TESTMODUS"))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_Link, {
        class: "parent-link",
        href: "/"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SvgIcon, {
            class: "icon",
            type: "mdi",
            path: _ctx.homeIcon
          }, null, 8, ["path"]),
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("p", {
        class: "parent-link",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open('cashRegister', _ctx.openParents.cashRegister)))
      }, [
        _createVNode(_component_SvgIcon, {
          class: "icon",
          type: "mdi",
          path: _ctx.cartIcon
        }, null, 8, ["path"]),
        _hoisted_5
      ]),
      _createVNode(_component_CollapseTransition, null, {
        default: _withCtx(() => [
          (_ctx.openParents.cashRegister)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_Link, {
                  href: _ctx.route('orders.create')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("1 Ny ordre")
                  ]),
                  _: 1
                }, 8, ["href"]),
                _hoisted_7,
                _createVNode(_component_Link, {
                  href: _ctx.route('orders.index', { type: 'orders' })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("3 Åpne ordre")
                  ]),
                  _: 1
                }, 8, ["href"]),
                _createVNode(_component_Link, {
                  href: _ctx.route('orders.index', { type: 'weborders' })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("4 Webordre")
                  ]),
                  _: 1
                }, 8, ["href"]),
                _hoisted_8,
                _hoisted_9,
                (_ctx.isAdmin)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_10, "7 Innstillinger"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("p", {
        class: "parent-link",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open('customers', _ctx.openParents.customers)))
      }, [
        _createVNode(_component_SvgIcon, {
          class: "icon",
          type: "mdi",
          path: _ctx.customerIcon
        }, null, 8, ["path"]),
        _hoisted_11
      ]),
      _createVNode(_component_CollapseTransition, null, {
        default: _withCtx(() => [
          (_ctx.openParents.customers)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _hoisted_14,
                _hoisted_15,
                _hoisted_16,
                (_ctx.isAdmin)
                  ? (_openBlock(), _createBlock(_component_Link, {
                      key: 0,
                      href: _ctx.route('customers.multiple_orders')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("5 Flere åpne ordre")
                      ]),
                      _: 1
                    }, 8, ["href"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("p", {
        class: "parent-link",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.open('timeSheet', _ctx.openParents.timeSheet)))
      }, [
        _createVNode(_component_SvgIcon, {
          class: "icon",
          type: "mdi",
          path: _ctx.clockIcon
        }, null, 8, ["path"]),
        _hoisted_17
      ]),
      _createVNode(_component_CollapseTransition, null, {
        default: _withCtx(() => [
          (_ctx.openParents.timeSheet)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _hoisted_19,
                (_ctx.isAdmin)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_20, "2 Administrer"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("p", {
        class: "parent-link",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.open('products', _ctx.openParents.products)))
      }, [
        _createVNode(_component_SvgIcon, {
          class: "icon",
          type: "mdi",
          path: _ctx.productsIcon
        }, null, 8, ["path"]),
        _hoisted_21
      ]),
      _createVNode(_component_CollapseTransition, null, {
        default: _withCtx(() => [
          (_ctx.openParents.products)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createVNode(_component_Link, {
                  href: _ctx.link('products.index')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("1 Produktliste")
                  ]),
                  _: 1
                }, 8, ["href"]),
                _hoisted_23,
                _hoisted_24,
                _createVNode(_component_Link, {
                  href: _ctx.link('attributes.index')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("4 Attributter")
                  ]),
                  _: 1
                }, 8, ["href"]),
                _createVNode(_component_Link, {
                  href: _ctx.link('product-brands.index')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("5 Varemerker")
                  ]),
                  _: 1
                }, 8, ["href"]),
                _hoisted_25,
                _createVNode(_component_Link, {
                  href: _ctx.link('products.remember-list.index')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("7 Datovarer")
                  ]),
                  _: 1
                }, 8, ["href"]),
                _createVNode(_component_Link, {
                  href: _ctx.link('products.remember-to-order.index')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("8 Bestilling-huskeliste")
                  ]),
                  _: 1
                }, 8, ["href"]),
                (_ctx.isAdmin)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_26, "9 Leverandører"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("p", {
        class: "parent-link",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.open('faqs', _ctx.openParents.faqs)))
      }, [
        _createVNode(_component_SvgIcon, {
          class: "icon",
          type: "mdi",
          path: _ctx.mdiFrequentlyAskedQuestions
        }, null, 8, ["path"]),
        _hoisted_27
      ]),
      _createVNode(_component_CollapseTransition, null, {
        default: _withCtx(() => [
          (_ctx.openParents.faqs)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createVNode(_component_Link, {
                  href: _ctx.link('faq.index')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("FAQ - liste")
                  ]),
                  _: 1
                }, 8, ["href"]),
                _createVNode(_component_Link, {
                  href: _ctx.link('faq-categories.index')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("FAQ - kategorier")
                  ]),
                  _: 1
                }, 8, ["href"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("p", {
        class: "parent-link",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.open('rfps', _ctx.openParents.rfps)))
      }, [
        _createVNode(_component_SvgIcon, {
          class: "icon",
          type: "mdi",
          path: _ctx.mdiFileDocument
        }, null, 8, ["path"]),
        _hoisted_29
      ]),
      _createVNode(_component_CollapseTransition, null, {
        default: _withCtx(() => [
          (_ctx.openParents.rfps)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createVNode(_component_Link, {
                  href: _ctx.link('rfp.index')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("RUH - liste")
                  ]),
                  _: 1
                }, 8, ["href"]),
                _createVNode(_component_Link, {
                  href: _ctx.link('rfp-categories.index')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("RUH - kategorier")
                  ]),
                  _: 1
                }, 8, ["href"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _hoisted_31,
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("p", {
        class: "parent-link",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.open('registry', _ctx.openParents.registry)))
      }, [
        _createVNode(_component_SvgIcon, {
          class: "icon",
          type: "mdi",
          path: _ctx.reportsIcon
        }, null, 8, ["path"]),
        _hoisted_33
      ]),
      _createVNode(_component_CollapseTransition, null, {
        default: _withCtx(() => [
          (_ctx.openParents.registry)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                (_ctx.isAdmin)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_35, "1 Salgsstatistikk"))
                  : _createCommentVNode("", true),
                (_ctx.isAdmin)
                  ? (_openBlock(), _createBlock(_component_Link, {
                      key: 1,
                      href: _ctx.link('reports.orders.hours')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("2 Ordrestatistikk")
                      ]),
                      _: 1
                    }, 8, ["href"]))
                  : _createCommentVNode("", true),
                (_ctx.isAdmin)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_36, "3 Varetelling"))
                  : _createCommentVNode("", true),
                _createVNode(_component_Link, {
                  href: _ctx.link('reports.out-of-production.week')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("4 Nylig utgåtte varer")
                  ]),
                  _: 1
                }, 8, ["href"]),
                (_ctx.isAdmin)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_37, "5 Oppgjørsoversikt"))
                  : _createCommentVNode("", true),
                (_ctx.isAdmin)
                  ? (_openBlock(), _createBlock(_component_Link, {
                      key: 4,
                      href: _ctx.link('reports.invoices.show')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("6 Fakturaoversikt")
                      ]),
                      _: 1
                    }, 8, ["href"]))
                  : _createCommentVNode("", true),
                (_ctx.isAdmin)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_38, "7 Varer solgt med tap"))
                  : _createCommentVNode("", true),
                (_ctx.isAdmin)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_39, "8 Varer ikke solgt"))
                  : _createCommentVNode("", true),
                (_ctx.isAdmin)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_40, "9 Provisjon"))
                  : _createCommentVNode("", true),
                _hoisted_41,
                _hoisted_42,
                _hoisted_43,
                _hoisted_44
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("a", _hoisted_46, [
        _createVNode(_component_SvgIcon, {
          class: "icon",
          type: "mdi",
          path: _ctx.registryIcon
        }, null, 8, ["path"]),
        _hoisted_47
      ])
    ]),
    (_ctx.isAdmin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _createElementVNode("a", _hoisted_49, [
            _createVNode(_component_SvgIcon, {
              class: "icon",
              type: "mdi",
              path: _ctx.usersIcon
            }, null, 8, ["path"]),
            _hoisted_50
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("a", _hoisted_52, [
        _createVNode(_component_SvgIcon, {
          class: "icon",
          type: "mdi",
          path: _ctx.logoutIcon
        }, null, 8, ["path"]),
        _hoisted_53
      ])
    ]),
    _createElementVNode("div", _hoisted_54, [
      _createElementVNode("a", {
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleNavSize && _ctx.toggleNavSize(...args))),
        class: "parent-link"
      }, [
        _createVNode(_component_SvgIcon, {
          class: _normalizeClass([{
            shrink: !_ctx.isSmall,
          }, "icon"]),
          type: "mdi",
          path: _ctx.expandIcon
        }, null, 8, ["class", "path"]),
        (_ctx.isSmall)
          ? (_openBlock(), _createElementBlock("span", _hoisted_55, "Utvid"))
          : (_openBlock(), _createElementBlock("span", _hoisted_56, "Krymp"))
      ])
    ])
  ], 2))
}